export default __webpack_public_path__ + "static/pangrampangram-5a5f22a775bfd5c74261ca9808fef926.svg";